import { ROUTE_STATUSES_MAP } from '@/modules/dispatcher/constants/filters'

/**
 * Приводит маршрут из CDC/WS (entity.Route: status — строка) к форме REST
 * (ext.RouteResponse: status — объект { id, name }), в которой маршруты лежат
 * в сторе и которую ожидает RouteCard.
 *
 * Идемпотентна: если status уже объект (пришёл из REST) — возвращает маршрут
 * без изменений.
 *
 * @param {object} route — маршрут из публикации Centrifugo
 * @returns {object} маршрут в форме ext.RouteResponse
 */
export function normalizeRoute(route) {
    if (!route || typeof route !== 'object') return route

    // Уже нормализован (REST-форма) — не трогаем.
    if (route.status && typeof route.status === 'object') {
        return route
    }

    const statusId = route.status
    const statusMeta = ROUTE_STATUSES_MAP[statusId]

    return {
        ...route,
        status: {
            id: statusId,
            name: statusMeta?.name ?? statusId,
        },
    }
}
